<template>
  <v-dialog :value="$store.getters['customers/manageCustomerDialog']" width="60%" persistent>
    <v-card>
      <v-card-title>Manage Customer</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field v-model.trim="customer.name" :rules="requiredRules" label="Name" required
                        @blur="autoCapOnBlur"/>
          <v-text-field v-model.trim="customer.email" label="Email" type="email"/>
          <v-text-field v-model.trim="customer.phone" label="Phone"/>
          <v-text-field v-model.trim="customer.mobile" label="Mobile"/>
          <v-text-field v-model.trim="customer.make" label="Make"/>
          <v-text-field v-model.trim="customer.model" label="Model"/>
          <v-text-field v-model.trim="customer.vrm" label="Registration Mark" @keyup="toUppercase"/>
          <v-text-field v-model.trim="customer.colour" label="Colour"/>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
        <v-btn :loading="isLoading" :disabled="isLoading" color="primary" @click="saveCustomer">Save Customer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {CustomersHttp} from "../../../http/customers";
import {EventBus} from "../../../EventBus";

export default {
  name: "ManageCustomerDialog",
  computed: {
    customer: {
      get() {
        return this.$store.state.customers.activeCustomer
      }
    }
  },
  methods: {
    autoCapOnBlur() {
      this.customer.name = this.customer.name.capitalize();
    },
    saveCustomer() {
      this.customer._id ? this.updateCustomer() : this.newCustomer();
    },
    async newCustomer() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          await CustomersHttp.createNewCustomer(this.customer);
          EventBus.$emit('message', {message: 'Customer Created Successfully', type: 'success'});
          await this.$store.dispatch('customers/setActiveCustomer', {});
          await this.$store.dispatch('customers/setManageCustomerDialog', false);
        } catch (e) {
          if (e.response) {
            EventBus.$emit('message', {message: e.response.data, type: 'error'});
          } else {
            EventBus.$emit('message', {message: e, type: 'error'});
          }

        } finally {
          this.isLoading = false;
        }
      }
    },
    async updateCustomer() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          await CustomersHttp.updateCustomer(this.customer._id, this.customer);
          EventBus.$emit('message', {message: 'Customer Saved Successfully', type: 'success'});
          await this.$store.dispatch('customers/setActiveCustomer', {});
          await this.$store.dispatch('customers/setManageCustomerDialog', false);
        } catch (e) {
          EventBus.$emit('message', {message: e, type: 'error'});
        } finally {
          this.isLoading = false;
        }
      }
    },
    async closeDialog() {
      await this.$store.dispatch('customers/setActiveCustomer', {});
      await this.$store.dispatch('customers/setManageCustomerDialog', false);
    },
    toUppercase() {
      this.customer.vrm = this.customer.vrm.toUpperCase();
    }
  },
  data() {
    return {
      isLoading: false,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      valid: true
    }
  }
}
String.prototype.capitalize = function () {
  return this.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
};
</script>

<style scoped>

</style>
